export default "__VITE_ASSET__CvIY0BqV__"